import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./src/locales/en/translation.json";
import zh from "./src/locales/zh/translation.json";
import ru from "./src/locales/ru/translation.json";
import ar from "./src/locales/ar/translation.json";
import es from "./src/locales/es/translation.json";
import fr from "./src/locales/fr/translation.json";
import ur from "./src/locales/ur/translation.json";
import he from "./src/locales/he/translation.json";
import pt from "./src/locales/pt/translation.json";
import bn from "./src/locales/bn/translation.json";
import hi from "./src/locales/hi/translation.json";

// Optional per-locale additions (tooltips) with a deep merge
import enTooltips from "./src/locales/en/tooltips.json";
import zhTooltips from "./src/locales/zh/tooltips.json";
import ruTooltips from "./src/locales/ru/tooltips.json";
import arTooltips from "./src/locales/ar/tooltips.json";
import esTooltips from "./src/locales/es/tooltips.json";
import frTooltips from "./src/locales/fr/tooltips.json";
import urTooltips from "./src/locales/ur/tooltips.json";
import heTooltips from "./src/locales/he/tooltips.json";
import ptTooltips from "./src/locales/pt/tooltips.json";
import bnTooltips from "./src/locales/bn/tooltips.json";
import hiTooltips from "./src/locales/hi/tooltips.json";

function deepMerge<T extends Record<string, any>>(base: T, extra: Partial<T>): T {
    const out: any = Array.isArray(base) ? [...(base as any)] : { ...base };
    for (const [k, v] of Object.entries(extra || {})) {
        if (v && typeof v === "object" && !Array.isArray(v)) {
            out[k] = deepMerge(out[k] || {}, v as any);
        } else {
            out[k] = v as any;
        }
    }
    return out as T;
}

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
export const resources = {
    en: { translation: deepMerge(en, enTooltips) },
    zh: { translation: deepMerge(zh, zhTooltips) },
    ru: { translation: deepMerge(ru, ruTooltips) },
    ar: { translation: deepMerge(ar, arTooltips) },
    es: { translation: deepMerge(es, esTooltips) },
    fr: { translation: deepMerge(fr, frTooltips) },
    ur: { translation: deepMerge(ur, urTooltips) },
    he: { translation: deepMerge(he, heTooltips) },
    pt: { translation: deepMerge(pt, ptTooltips) },
    bn: { translation: deepMerge(bn, bnTooltips) },
    hi: { translation: deepMerge(hi, hiTooltips) },
} satisfies import("i18next").Resource;

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;
